import { map, catchError } from "rxjs";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { jwtDecode } from "jwt-decode";
import * as _ from "lodash";
import * as toastr from "toastr";
import { UserSessionType } from "../../utils/types/core/models/user-session.type";
import { CredentialsType } from "../../utils/types/security/credentials.type";
import { SecurityMapper } from "../../utils/mappers/security/security.mapper";
import { ICurrentUser } from "../../utils/interfaces/security/icurrent-user.interface";
import { environment as env } from "../../../environments/environment";
import { ObservableDataService } from "../core/observable-data.service";
import { JwtHelperService } from "@auth0/angular-jwt";
import { of } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";

@Injectable({ providedIn: "root" })
export class AuthenticationService {
    loggedUserInfo: UserSessionType;

    defaultHeaders = new HttpHeaders().set(
        "Content-Type",
        "application/x-www-form-urlencoded"
    );

    // Constructor.
    constructor(
        private http: HttpClient,
        private securityMapper: SecurityMapper,
        private ods: ObservableDataService,
        private jwt: JwtHelperService,
        private router: Router,
        private translateService: TranslateService
    ) {}

    // Perform login method.
    login(credentials: any): Observable<any> {
        this.logout();

        return this.http
            .post(env.ApiUrl + "auth/login", credentials, {
                headers: new HttpHeaders({
                    apiKey: env.apiKey,
                }),
                responseType: "text",
            })
            .pipe(
                map((res) => {
                    if (typeof res === "string") {
                        return this.saveToken(res);
                    }
                    return res;
                })
            );
    }

    resendPin(username: string) {
        return this.http.post(
            env.ApiUrl + "auth/resend/pin",
            {
                username,
                domain: location.hostname.includes("localhost")
                    ? env.domain
                    : location.hostname,
            },
            {
                headers: new HttpHeaders({
                    apiKey: env.apiKey,
                }),
            }
        );
    }

    getPin(credentials: CredentialsType) {
        return this.http.post(env.ApiUrl + "auth/generate/pin", credentials, {
            headers: new HttpHeaders({
                apiKey: env.apiKey,
            }),
            responseType: "text",
        });
    }

    // Get the current user information.
    getCurrentUserInformation(): Observable<ICurrentUser> {
        const info = localStorage.getItem(env.accessTokenLocalStorageKey);

        return this.http.get<ICurrentUser>(env.ApiUrl + "api/profile/user", {
            headers: new HttpHeaders({
                apiKey: env.apiKey,
                Authorization: "Bearer " + JSON.parse(info).token,
            }),
        });
    }

    getCompanyProfile(): Observable<any> {
        const info = localStorage.getItem(env.accessTokenLocalStorageKey);

        return this.http.get<ICurrentUser>(
            env.ApiUrl + "api/profile/mycompany",
            {
                headers: new HttpHeaders({
                    apiKey: env.apiKey,
                    Authorization: "Bearer " + JSON.parse(info).token,
                }),
            }
        );
    }

    getToken(): string {
        const info = localStorage.getItem(env.accessTokenLocalStorageKey);

        if (!info) {
            return null;
        } else {
            return JSON.parse(info).token;
        }
    }

    logout() {
        this.loggedUserInfo = null;
        localStorage.removeItem(env.accessTokenLocalStorageKey);
        sessionStorage.clear();
    }

    private saveToken(tokenData: any) {
        //  localStorage.setItem(env.accessTokenLocalStorageKey, tokenData);
        // tslint:disable-next-line:prefer-const
        let info: UserSessionType = new UserSessionType();
        info.token = tokenData;
        const tokenDecoded: any = jwtDecode(tokenData);
        info.isOwner = tokenDecoded.isOwner;
        info.companyId = tokenDecoded.companyId;
        info.companyEmail = tokenDecoded.companyEmail;
        info.companyIsSaaSOwner = tokenDecoded.companySaaSOwner;
        info.fullName = tokenDecoded.fullname;
        info.id = tokenDecoded.id;
        info.avatarUrl = tokenDecoded.avatarUrl;
        info.modules = tokenDecoded.modules;
        info.menu = tokenDecoded.menu;
        info.isNewUser = tokenDecoded.isNewUser;
        info.userEmail = tokenDecoded.email;
        info.firstName = tokenDecoded.firstName;
        info.lastName = tokenDecoded.lastName;
        info.childrenCompanies = tokenDecoded.childrenCompanies;
        info.has2FA = tokenDecoded.has2FA;

        console.log(info);

        localStorage.setItem(
            env.accessTokenLocalStorageKey,
            JSON.stringify(info)
        );
        //  this.savePermissions(this.loggedUserInfo.token);
        this.loggedUserInfo = info;
        this.ods.setloggedUser(info);
        return this.loggedUserInfo;
    }

    isLoggedIn() {
        const sessionInfo = this.ods.getLoggedUser();

        if (sessionInfo.token) {
            if (!this.jwt.isTokenExpired(sessionInfo.token)) {
                return true;
            }
        }

        return false;
    }
}
